import { render } from "./pdfviewer.vue?vue&type=template&id=58109394&scoped=true"
import script from "./pdfviewer.vue?vue&type=script&lang=js"
export * from "./pdfviewer.vue?vue&type=script&lang=js"

import "./pdfviewer.vue?vue&type=style&index=0&id=58109394&lang=css"
import "@/assets/css/Pdfviewer.scss?vue&type=style&index=1&id=58109394&lang=scss&scoped=true"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58109394"]])

export default __exports__